import { Injectable } from '@angular/core';

@Injectable()
export class CMoveProgress {

    //PROPERTIES

    request_id: any;
    user: any;
    state: any;
    remaining: any;
    complete: any;
    failed: any;
    canceled: any;
    warned: any;
    wado_patient_record_id: any;
    wado_study_record_id: any;

    //CONSTRUCTOR
    constructor();
    constructor(request: any);
    constructor(request?: any) {
        this.request_id = (request) ? request.request_id : null;
        this.user = (request) ? request.user : null;
        this.state = (request) ? request.state : null;
        this.remaining = (request) ? request.remaining : 0;
        this.complete = (request) ? request.complete : 0;
        this.failed = (request) ? request.failed : 0;
        this.canceled = (request) ? request.canceled : 0;
        this.warned = (request) ? request.warned : 0;
        this.wado_patient_record_id = (request) ? request.wado_patient_record_id : null;
        this.wado_study_record_id = (request) ? request.wado_study_record_id : null;
    } //end constructor

} //end class